import React, { useContext, useEffect, useState } from "react";
import { AppContextType, WonmovContext } from "@/context/app-context";
import walletIcon from "@public/img/wallet.svg";
import Tabs from "@/component/commom/tabs";
import loadingGif from "@public/img/loading.gif";
import { userRepo } from "@/repo/user-repo";
import { TransactionData } from "@/entry/server/user";
import { Pagination } from "@/lib/api";
import PaginationView from "@/component/commom/pagination";
import { formatPrice } from "@/utils/common_helpers";

var tabs = ["کیف پول", "تراکنش ها"];

var chargeAmounts = [
    { label: "۵۰,۰۰۰", value: 50000 },
    { label: "۱۰۰,۰۰۰", value: 100000 },
    { label: "۲۰۰,۰۰۰", value: 200000 },
];

export default function WalletPage() {
    const { setNotification } = useContext<AppContextType>(WonmovContext);
    const [walletBalance, setWalletBalance] = useState(-1);
    const [selectedTab, setSelectedTab] = useState(0);
    const [transactions, setTransactions] = useState<TransactionData[]>([]);
    const [transactionsLoading, setTransactionsLoading] = useState(true);
    const [transactionsPage, setTransactionsPage] = useState(1);
    const [pagination, setPagination] = useState<Pagination | undefined>(undefined);

    useEffect(function () {
        userRepo.getWalletBalance().then(function (res) {
            if (!res.status) {
                setNotification({ type: "danger", message: res.message });
                return;
            }
            setWalletBalance(res.data !== undefined && res.data !== null ? res.data : 0);
        });
    }, []);

    useEffect(function () {
        setTransactionsLoading(true);
        userRepo.getTransactions(transactionsPage).then(function (res) {
            if (!res.status) {
                setNotification({ type: "danger", message: res.message });
                setTransactionsLoading(false);
                return;
            }
            setTransactions(res.data ? res.data : []);
            setPagination(res.pagination ? res.pagination : undefined);
            setTransactionsLoading(false);
        });
    }, [transactionsPage]);

    return (
        <div className="wallet-page">
            <div className="wallet-balance bg-main-radial-gradient-r">
                <img src={walletIcon} alt="wallet" className="wallet-balance__icon" />
                <div className="wallet-balance__info">
                    <p className="wallet-balance__label">موجودی کیف پول:</p>
                    {walletBalance === -1 ? (
                        <img src={loadingGif} alt="loading" className="white-loader" />
                    ) : (
                        <p className="wallet-balance__amount">
                            <span className="wallet-balance__amount-value">{formatPrice(walletBalance)}</span> تومان
                        </p>
                    )}
                </div>
            </div>

            <div className="profile-panel wallet-panel">
                <Tabs tabs={tabs} selectedTab={selectedTab} onChange={setSelectedTab} />

                {selectedTab === 0 && <WalletInfo />}
                {selectedTab === 1 && (
                    <WalletTransactions
                        transactions={transactions}
                        transactionsLoading={transactionsLoading}
                        setTransactionsPage={setTransactionsPage}
                        pagination={pagination}
                    />
                )}
            </div>
        </div>
    );
}

function WalletInfo() {
    return (
        <div>
            <p className="subscription-notice">
                برای شارژ کیف پول، سایت را در گوشی یا کامپیوتر باز کنید.
            </p>

            <div className="wallet-amounts">
                {chargeAmounts.map(function (item, index) {
                    return (
                        <div key={index} className="wallet-amounts__item">
                            <div className="wallet-amount-card">
                                {item.label}{" "}
                                <span className="wallet-amount-card__currency">تومان</span>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

function WalletTransactions({
    transactions,
    transactionsLoading,
    setTransactionsPage,
    pagination,
}: {
    transactions: TransactionData[];
    transactionsLoading: boolean;
    setTransactionsPage: (page: number) => void;
    pagination: Pagination | undefined;
}) {
    if (transactionsLoading) {
        return <img src={loadingGif} alt="loading" className="wallet-transactions__loading" />;
    }

    return (
        <div className="wallet-transactions">
            <table className="wallet-transactions__table">
                <thead>
                    <tr>
                        <th>شناسه</th>
                        <th>مبلغ</th>
                        <th>عنوان</th>
                        <th className="wallet-transactions__date-col">تاریخ ایجاد</th>
                        <th>وضعیت</th>
                    </tr>
                </thead>
                <tbody>
                    {transactions.map(function (transaction) {
                        var statusClass = "wallet-transactions__status wallet-transactions__status--pending";
                        var statusLabel = "درحال پرداخت";
                        if (transaction.status === "paid") {
                            statusClass = "wallet-transactions__status wallet-transactions__status--paid";
                            statusLabel = "پرداخت شده";
                        } else if (transaction.status === "failed") {
                            statusClass = "wallet-transactions__status wallet-transactions__status--failed";
                            statusLabel = "پرداخت ناموفق";
                        }

                        return (
                            <tr key={transaction.id}>
                                <td>{transaction.id}</td>
                                <td>{transaction.amount}</td>
                                <td>{transaction.type}</td>
                                <td className="wallet-transactions__date wallet-transactions__date-col">{transaction.date}</td>
                                <td>
                                    <span className={statusClass}>{statusLabel}</span>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>

            {pagination && (
                <div className="wallet-transactions__pagination">
                    <PaginationView pagination={pagination} black={true} onChange={setTransactionsPage} />
                </div>
            )}
        </div>
    );
}
